module.exports = __webpack_public_path__ + "static/img/bg-confirm.0075b1ad.svg";